import { createAsyncThunk } from '@reduxjs/toolkit';

import { RuleService } from '../../services';

export const fetchRules = createAsyncThunk('rule/fetchRules', async (params, { rejectWithValue }) => {
  try {
    const response = await RuleService.fetchRules(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch rules');
  }
});

export const fetchRule = createAsyncThunk('rule/fetchRule', async ({ id, params }, { rejectWithValue }) => {
  try {
    const response = await RuleService.fetchRule(id, params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch rule');
  }
});

export const snoozeRules = createAsyncThunk('rule/snoozeRules', async (data, { rejectWithValue }) => {
  try {
    await RuleService.snoozeRules(data);

    return { ids: data.ids, snooze: data.seconds !== -1 };
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to snooze rules');
  }
});
